import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';

const Wrapper = styled.div``;

const Title = styled.strong``;

const List = styled.ul`
    display: inline-block;
    margin: 0;
    padding: 0;
    list-style: none;
`;

const Item = styled.li`
    position: relative;
    display: inline-block;

    img {
        margin-right: 3px;
    }

    &:not(:last-child)::after {
        content: ',';
        margin-right: 6px;
    }
`;

const InterestItemList = ({ title = '', itemIdList = [], mapItems = {} }) => {
    if (!itemIdList.length || !Object.keys(mapItems).length) {
        return null;
    }

    return (
        <Wrapper>
            {title && <Title>{title}</Title>}
            <List>
                {itemIdList.map(itemId => (
                    <Item key={itemId}>
                        {mapItems[itemId] &&
                            mapItems[itemId].countryId && (
                                <img
                                    width="15"
                                    height="10"
                                    src={RCore.imageUrls.getFlagImg(mapItems[itemId].countryId, 15, 10)}
                                    alt="Country flag"
                                />
                            )}
                        {mapItems[itemId] && mapItems[itemId].name}
                    </Item>
                ))}
            </List>
        </Wrapper>
    );
};

InterestItemList.propTypes = {
    title: PropTypes.string,
    itemIdList: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
    mapItems: PropTypes.shape({
        name: PropTypes.string,
        countryId: PropTypes.number
    }).isRequired
};

export default InterestItemList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/InterestsTable/InterestItemList.js
 **/